<template>
  <el-select v-model="value" filterable @placeholder="placeholdertext"  @change="change">
    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: 'FormUserSelect',
  data () {
    return {
      options: [{
        value: '0',
        label: '张三'
      }, {
        value: '1',
        label: '张三1'
      }],
      placeholdertext: '请选择',
      value: ''
    }
  },
  methods: {
    change: function () {
      this.$emit('input', this.value)
    }
  }
}
</script>

<style scoped="scoped">
  .el-select {
    width: 100%;
  }
</style>
